/**
 * COURE.HUB.DS.TransactionLog.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type StatusCodeEnum = 100 | 101 | 102 | 103 | 104 | 105 | 106 | 107 | 108 | 109 | 200;

export const StatusCodeEnum = {
    NUMBER_100: 100 as StatusCodeEnum,
    NUMBER_101: 101 as StatusCodeEnum,
    NUMBER_102: 102 as StatusCodeEnum,
    NUMBER_103: 103 as StatusCodeEnum,
    NUMBER_104: 104 as StatusCodeEnum,
    NUMBER_105: 105 as StatusCodeEnum,
    NUMBER_106: 106 as StatusCodeEnum,
    NUMBER_107: 107 as StatusCodeEnum,
    NUMBER_108: 108 as StatusCodeEnum,
    NUMBER_109: 109 as StatusCodeEnum,
    NUMBER_200: 200 as StatusCodeEnum
};